// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__FfGgE","label":"Category_label__2YGQG","content":"Category_content__3dpOS","header":"Category_header__3Ibee","location":"Category_location__1PXjK"};